import {
  HOME_CRUMB,
} from 'constants/constants';
import { ASSET_UPLOAD, HOME_PAGE, JOBS } from 'constants/routes';

export const loginUser = {
  username: 'santhosh.muttennavar',
  id: 339321361,
  message_digest: '491c6f091fe37ff79133798a76659c952fd75d2f',
  role_name: 'Administrator',
  user_full_name: 'Das, Rahul',
  user_id: '374',
  login_name: 'rahul.das@thermofisher.com',
  user_role_id: 1
};

export const listTable = {
  list: [
    {
      bulkUploadId: 459,
      uploadedDate: '2023-09-26T00:00:00',
      completedDate: '2023-09-26T00:00:00',
      assetCount: 8,
      status: 'Created',
      errorMessage: 'No Error',
      userId: 'anikesh.banik',
      jobName: 'TestJob',
      fileName: 'Bulk_Template.xlsx'
    },
    {
      bulkUploadId: 457,
      uploadedDate: '2023-09-26T00:00:00',
      completedDate: '2023-09-27T00:00:00',
      assetCount: 2,
      status: 'Created',
      errorMessage: '',
      userId: 'anikesh.banik',
      jobName: 'TestJob2',
      fileName: 'File2'
    },
    {
      bulkUploadId: 460,
      uploadedDate: '2023-09-26T00:00:00',
      completedDate: '2023-09-26T00:00:00',
      assetCount: 8,
      status: 'Published',
      errorMessage: 'No Error',
      userId: 'anikesh.banik',
      jobName: 'CitationBulkUploadFile',
      fileName: 'Bulk_Template.xlsx'
    },
    {
      bulkUploadId: 461,
      uploadedDate: '2023-09-26T00:00:00',
      completedDate: '2023-09-26T00:00:00',
      assetCount: 8,
      status: 'Failed',
      errorMessage: 'No Error',
      userId: 'anikesh.banik',
      jobName: 'CitationBulkUploadFile',
      fileName: 'Bulk_Template.xlsx'
    },
    {
      bulkUploadId: 456,
      uploadedDate: '2023-09-25T00:00:00',
      completedDate: '2023-09-27T00:00:00',
      assetCount: 2,
      status: 'Completed',
      errorMessage: '',
      userId: 'anikesh.banik',
      jobName: 'TestJob1',
      fileName: 'File1'
    },
    {
      bulkUploadId: 458,
      uploadedDate: '2023-09-24T00:00:00',
      completedDate: '2023-09-25T00:00:00',
      assetCount: 2,
      status: 'Created',
      errorMessage: '',
      userId: 'anikesh.banik',
      jobName: 'TestJob3',
      fileName: 'File3'
    },
    {
      bulkUploadId: 458,
      uploadedDate: '2023-09-24T00:00:00',
      completedDate: '2023-09-25T00:00:00',
      assetCount: 2,
      status: 'Progress',
      errorMessage: '',
      userId: 'anikesh.banik',
      jobName: 'TestJob3',
      fileName: 'File3'
    }
  ],
  totalCount: 7
};

export const listTableDetails = {
  list: [
    {
      id: 1027,
      assetJobId: 198938,
      assetName: 'Citation1.jpg',
      createdDate: '2023-10-16T13:21:33.786157',
      updatedDate: '2023-10-16T13:22:15.41536',
      status: 'Completed',
      errorMessage: null,
      bulkUploadId: 509,
      userId: 'anilkumar.sr',
      assetId: '47bdfd7e2468ef5d14fa238b3f4aa35f4dc8ce92'
    },
    {
      id: 1028,
      assetJobId: 198939,
      assetName: 'Citation2.jpg',
      createdDate: '2023-10-16T13:21:36.019308',
      updatedDate: '2023-10-16T13:22:20.656551',
      status: 'Completed',
      errorMessage: null,
      bulkUploadId: 509,
      userId: 'anilkumar.sr',
      assetId: 'fd5e095e8d9516d6980b0710b6dabea5c2aa49cd'
    },
    {
      id: 1029,
      assetJobId: 198940,
      assetName: 'Citation3.jpg',
      createdDate: '2023-10-16T13:21:36.774459',
      updatedDate: '2023-10-16T13:22:24.735869',
      status: 'Failed',
      errorMessage: null,
      bulkUploadId: 509,
      userId: 'anilkumar.sr',
      assetId: '2093d4be99300cf48b4b621ad1d075d6df3de921'
    },
    {
      id: 1030,
      assetJobId: 198941,
      assetName: 'Citation4.jpg',
      createdDate: '2023-10-16T13:21:37.778477',
      updatedDate: '2023-10-16T13:23:19.268255',
      status: 'Completed',
      errorMessage: null,
      bulkUploadId: 509,
      userId: 'anilkumar.sr',
      assetId: '2d4e3918d387495042b4e25fc543a89f16663ad8'
    },
    {
      id: 1031,
      assetJobId: 198942,
      assetName: 'Citation5.jpg',
      createdDate: '2023-10-16T13:21:38.913358',
      updatedDate: '2023-10-16T13:23:23.807539',
      status: 'Completed',
      errorMessage: null,
      bulkUploadId: 509,
      userId: 'anilkumar.sr',
      assetId: 'b7ff21a53e4d002c93b91ceea80167cf3b31a3fa'
    },
    {
      id: 1032,
      assetJobId: 198943,
      assetName: 'Citation1.jpg',
      createdDate: '2023-10-16T13:21:40.038371',
      updatedDate: '2023-10-16T13:23:28.222017',
      status: 'Completed',
      errorMessage: null,
      bulkUploadId: 509,
      userId: 'anilkumar.sr',
      assetId: '0c7ce326a2a5fd1a859cc7e577be520b2cb181a2'
    }
  ],
  totalCount: 16
};


export const buildBreadCrumbData = (pathname) => {
  const id = pathname.split('/')[4]; // Extract the ID from the URL
  const breadcrumbMappings = {
    [`/job-status-detail-view`]: [
      { label: HOME_CRUMB, path: HOME_PAGE },
      { label: 'Digital Asset Management', path: HOME_PAGE },
      { label: 'Detailed View', path: pathname },
    ],
    
    default: [
      { label: HOME_CRUMB, path: '/store/admin' },
      { label: 'Digital Asset Management', path: HOME_PAGE },
    ]
  };

  return breadcrumbMappings[`/${id}`] || breadcrumbMappings.default;
};

export const buildBreadCrumbDataNew = (pathname, isSearch) => {
  const id = pathname.split('/')[4]; // Extract the ID from the URL
  const breadcrumbMappings = {
    '/asset-upload': [
      { label: HOME_CRUMB, path: '/store/admin' },
      { label: 'Digital Asset Management', path: HOME_PAGE },
      { label: 'Upload Assets', path: ASSET_UPLOAD },
    ],
    '/jobs':[
      { label: HOME_CRUMB, path: '/store/admin' },
      { label: 'Digital Asset Management', path: HOME_PAGE },
      { label: 'My Jobs', path: JOBS }
    ],
    [`/job-details`]: [
      { label: HOME_CRUMB, path: '/store/admin' },
      { label: 'Digital Asset Management', path: HOME_PAGE },
      { label: 'My Jobs', path: JOBS },
      { label: 'Job Details', path: pathname },
    ],
    [`/asset-detail`]: [
      { label: HOME_CRUMB, path: '/store/admin' },
      { label: 'Digital Asset Management', path: HOME_PAGE },
      { label: 'Asset Detail', path: pathname },
    ],
    [`/asset-edit`]: [
      { label: HOME_CRUMB, path: '/store/admin' },
      { label: 'Digital Asset Management', path: HOME_PAGE },
      { label: 'Asset Edit', path: pathname },
    ],
    [`/asset-check-in`]: [
      { label: HOME_CRUMB, path: '/store/admin' },
      { label: 'Digital Asset Management', path: HOME_PAGE },
      { label: 'Asset Check-In', path: pathname },
    ],
    default: [
      { label: HOME_CRUMB, path: '/store/admin' },
      { label: 'Digital Asset Management', path: HOME_PAGE },
      { label: isSearch ? 'Search Results' : 'My Recent Uploads', path: HOME_PAGE }
    ]
  };

  return breadcrumbMappings[`/${id}`] || breadcrumbMappings.default;
};

export const titleCase = (str) => {
  if (!str) {
    return '-';
  }
  return str
    .toLowerCase()
    .split('_')
    .map(function (word) {
      return word.replace(word[0], word[0].toUpperCase());
    })
    .join(' ');
};

export const getFirstNameLastName = (fullName) => {
  if (!fullName) {
    return '';
  }
  const name = fullName.split(',');
  if (name.length > 1) {
    return name[1] + ' ' + name[0];
  }
  return fullName;
};

export const isNewUIEnabled = (unleashValue, unleashError, loading) => {
  let newUI = false;
  if (unleashValue?.enabled && !unleashError && !loading) {
    newUI = true;
  }
  return newUI;
};

export const dateFormatter = (dateString) => {
  if (!dateString) {
    return '-';
  }
  const date = new Date(dateString);
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
};

export const dateTimeFormatter = (dateString) => {
  if (!dateString) {
    return '-';
  }
  const date = new Date(dateString);
  return date.toLocaleString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hourCycle: 'h24'
  });
};

export const generateTableData = (metadataElementList) => {
  const groupedData = metadataElementList?.reduce((acc, category) => {
    const groupedByMetaTableId = category.metadata_element_list.reduce(
      (group, element) => {
        if (element.is_tabular === 'Y' && element.meta_table_id) {
          if (!group[element.meta_table_id]) {
            group[element.meta_table_id] = [];
          }
          group[element.meta_table_id].push(element);
        }
        return group;
      },
      {}
    );

    Object.keys(groupedByMetaTableId).forEach((metaTableId) => {
      acc.push({
        name: category.id,
        meta_table_id: metaTableId,
        elements: groupedByMetaTableId[metaTableId]
      });
    });

    return acc;
  }, []);
  return groupedData;

  // Ensure no return value as per the requirement
};

// assetMetadata find out the element having prompt original file path
export const findElementByPrompt = (data, prompt) => {
  const metadataElementList =
    data?.metadata_collection?.metadata_element_list || [];

  for (const category of metadataElementList) {
    const elements = category.metadata_element_list || [];
    for (const element of elements) {
      if (element.prompt === prompt) {
        return element; // Return the element if the prompt matches
      }
    }
  }

  return false; // Return null if no matching element is found
};

// parsing the product name/title
export const domParser=(value)=>{
  if(!value) {
    return '';
  }
  return new DOMParser().parseFromString(value, "text/html").documentElement.textContent || '';
};

export const getAllElementsByMetaTableId = (data, metaTableId) => {
  const metadataElementList =
    data?.metadata_collection?.metadata_element_list || [];

  const matchingElements = [];

  for (const category of metadataElementList) {
    const elements = category.metadata_element_list || [];
    for (const element of elements) {
      if (element.meta_table_id === metaTableId) {
        matchingElements.push(element); // Add the element to the array if the meta_table_id matches
      }
    }
  }

  return matchingElements; // Return all matching elements
};

export const getAllElementsByCascadeTableId = (data, cascadeTableId) => {
  const metadataElementList =
    data?.metadata_collection?.metadata_element_list || [];

  const matchingElements = [];

  for (const category of metadataElementList) {
    const elements = category.metadata_element_list || [];
    for (const element of elements) {
      if (element.cascade_table_id === cascadeTableId) {
        matchingElements.push(element); // Add the element to the array if the cascade_table_id matches
      }
    }
  }

  return matchingElements; // Return all matching elements
};

// Helper function to extract display value from value/values structure
const extractDisplayValue = (obj) => {
  if (!obj) {
    return '';
  }
  
  // If it has a 'value' object, extract display_value
  if (obj.value && typeof obj.value === 'object') {
    const displayValue = obj.value.display_value || obj.value.id || '';
    // Don't show value if both id and display_value are empty
    if (!obj.value.display_value && !obj.value.id) {
      return '';
    }
    return displayValue;
  }
  
  // If it has a 'values' array, extract display_value from first item or concatenate all
  if (obj.values && Array.isArray(obj.values)) {
    if (obj.values.length === 0) {
      return '';
    }
    if (obj.values.length === 1) {
      const value = obj.values[0];
      // Don't show value if both id and display_value are empty
      if (!value.display_value && !value.id) {
        return '';
      }
      return value.display_value || value.id || '';
    }
    // For multiple values, filter out empty ones, deduplicate, and concatenate
    const nonEmptyValues = obj.values
      .filter(val => val.display_value || val.id)
      .map(val => val.display_value || val.id || '')
      .filter((value, index, array) => array.indexOf(value) === index); // Deduplicate
    return nonEmptyValues.join(', ');
  }
  
  return '';
};

// Deep object comparison utility function specifically for metadata objects
export const compareObjects = (objectA, objectB, path = '') => {
  const differences = [];

  // Handle null/undefined cases
  if (objectA === null || objectA === undefined || objectB === null || objectB === undefined) {
    if (objectA !== objectB) {
      differences.push({
        path: path || 'root',
        label: 'Root',
        firstValue: objectA,
        secondValue: objectB,
        type: 'value_difference'
      });
    }
    return differences;
  }

  // Handle primitive types
  if (typeof objectA !== 'object' || typeof objectB !== 'object') {
    if (objectA !== objectB) {
      differences.push({
        path: path || 'root',
        label: 'Root',
        firstValue: objectA,
        secondValue: objectB,
        type: 'value_difference'
      });
    }
    return differences;
  }

  // Handle arrays (metadata_element_list)
  if (Array.isArray(objectA) || Array.isArray(objectB)) {
    if (Array.isArray(objectA) !== Array.isArray(objectB)) {
      differences.push({
        path: path || 'root',
        label: 'Array Type',
        firstValue: objectA,
        secondValue: objectB,
        type: 'type_difference'
      });
      return differences;
    }

    if (objectA.length !== objectB.length) {
      differences.push({
        path: path || 'root',
        label: 'Array Length',
        firstValue: `Array[${objectA.length}]`,
        secondValue: `Array[${objectB.length}]`,
        type: 'array_length_difference'
      });
    }

    const maxLength = Math.max(objectA.length, objectB.length);
    for (let i = 0; i < maxLength; i++) {
      const currentPath = path ? `${path}[${i}]` : `[${i}]`;
      const nestedDiffs = compareObjects(objectA[i], objectB[i], currentPath);
      differences.push(...nestedDiffs);
    }

    return differences;
  }

  // Get all unique keys from both objects
  const allKeys = new Set([...Object.keys(objectA), ...Object.keys(objectB)]);

  for (const key of allKeys) {
    const currentPath = path ? `${path}.${key}` : key;

    if (!(key in objectA)) {
      const label = objectB[key]?.prompt || key;
      const secondValue = extractDisplayValue(objectB[key]);
      differences.push({
        path: currentPath,
        label: label,
        firstValue: undefined,
        secondValue: secondValue || objectB[key],
        type: 'missing_in_obj1'
      });
    } else if (!(key in objectB)) {
      const label = objectA[key]?.prompt || key;
      const firstValue = extractDisplayValue(objectA[key]);
      differences.push({
        path: currentPath,
        label: label,
        firstValue: firstValue || objectA[key],
        secondValue: undefined,
        type: 'missing_in_obj2'
      });
    } else {
      // Special handling for metadata elements with prompt
      if (objectA[key]?.prompt && objectB[key]?.prompt) {
        const label = objectA[key].prompt;
        const firstValue = extractDisplayValue(objectA[key]);
        const secondValue = extractDisplayValue(objectB[key]);
        
        // Only add difference if the display values are different
        if (firstValue !== secondValue) {
          differences.push({
            path: currentPath,
            label: label,
            firstValue: firstValue,
            secondValue: secondValue,
            type: 'value_difference'
          });
        }
        
        // Continue checking other properties of the metadata element
        const otherKeys = new Set([...Object.keys(objectA[key]), ...Object.keys(objectB[key])]);
        for (const subKey of otherKeys) {
          if (subKey !== 'value' && subKey !== 'values' && subKey !== 'prompt') {
            const nestedDiffs = compareObjects(objectA[key][subKey], objectB[key][subKey], `${currentPath}.${subKey}`);
            differences.push(...nestedDiffs);
          }
        }
      } else {
        // Recursively compare nested objects
        const nestedDiffs = compareObjects(objectA[key], objectB[key], currentPath);
        differences.push(...nestedDiffs);
      }
    }
  }

  return differences;
};

// Simplified object comparison (returns boolean)
export const areObjectsEqual = (objectA, objectB) => {
  return compareObjects(objectA, objectB).length === 0;
};

// Audit comparison function specifically for metadata elements
export const compareObjectsForAudit = (objectA, objectB) => {
  const auditResults = [];
  
  // Helper function to extract all metadata elements from nested structure
  const extractAllElements = (obj) => {
    const elements = [];
    
    // Check if there's a direct metadata_element_list at root
    if (obj?.metadata_element_list && Array.isArray(obj.metadata_element_list)) {
      obj.metadata_element_list.forEach(element => {
        if (element.field_id) {
          elements.push(element);
        }
      });
    }
    
    // Check if there's a nested structure via metadata_collection
    if (obj?.metadata_collection?.metadata_element_list && Array.isArray(obj.metadata_collection.metadata_element_list)) {
      obj.metadata_collection.metadata_element_list.forEach(category => {
        if (category.metadata_element_list && Array.isArray(category.metadata_element_list)) {
          category.metadata_element_list.forEach(element => {
            if (element.field_id) {
              elements.push(element);
            }
          });
        }
      });
    }
    
    return elements;
  };
  
  // Extract metadata_element_list from both objects using the helper
  const elements1 = extractAllElements(objectA);
  const elements2 = extractAllElements(objectB);
  
  // Create maps for quick lookup by field_id
  const elements1Map = new Map();
  const elements2Map = new Map();
  
  elements1.forEach(element => {
    if (element.field_id) {
      elements1Map.set(element.field_id, element);
    }
  });
  
  elements2.forEach(element => {
    if (element.field_id) {
      elements2Map.set(element.field_id, element);
    }
  });
  
  // Get all unique field_ids
  const allFieldIds = new Set([...elements1Map.keys(), ...elements2Map.keys()]);
  
  allFieldIds.forEach(fieldId => {
    const element1 = elements1Map.get(fieldId);
    const element2 = elements2Map.get(fieldId);
    
    const prompt = element1?.prompt || element2?.prompt || fieldId;
    const datatype = element1?.datatype || element2?.datatype || '';
    const displayValue1 = element1 ? extractDisplayValue(element1) : '';
    const displayValue2 = element2 ? extractDisplayValue(element2) : '';
    
    // Determine status
    let status = 'unchanged';
    if (!element1 && element2) {
      status = 'added';
    } else if (element1 && !element2) {
      status = 'removed';
    } else if (displayValue1 !== displayValue2) {
      status = 'changed';
    }
    
    // Only include items that have differences or if explicitly requested to show all
    const hasDifference = status !== 'unchanged';
    if (hasDifference) {
      auditResults.push({
        field_id: fieldId,
        prompt: prompt,
        datatype: datatype,
        obj1_display_value: displayValue1,
        obj2_display_value: displayValue2,
        status: status,
        has_difference: hasDifference
      });
    }
  });
  
  // Sort by prompt for better readability
  auditResults.sort((a, b) => a.prompt.localeCompare(b.prompt));
  
  return auditResults;
};

// Get audit summary statistics
export const getAuditSummary = (auditResults) => {
  const summary = {
    total: auditResults.length,
    unchanged: 0,
    changed: 0,
    added: 0,
    removed: 0
  };
  
  auditResults.forEach(result => {
    summary[result.status]++;
  });
  
  return summary;
};

export const getFirstNameLastNameFromEmailId = (fullName) => {
  if (!fullName) {
    return '';
  }
  const name = fullName.split('@');
  if (name.length > 1) {
    return name[0].replace('.',' ');
  }
  return fullName;
};